type ID = {id: string}

export type RecordIDModel<props extends string | number | symbol> = ID & Record<props, string>

export type StateType<DataType> = {
  [id: string]: DataType,
}

export const defaults = <DataType>(arr: ReadonlyArray<string>): DataType => arr.reduce((prev, current) => ({
  ...prev,
  [current]: '',
}), {} as DataType);

type CRUDReducer<DataType> = {
  CREATE: (state: StateType<DataType>, id: string, data?: Partial<DataType>) => StateType<DataType>,
  UPDATE: (state: StateType<DataType>, data: Partial<DataType>, id: string) => StateType<DataType>,
  DELETE: (state: StateType<DataType>, id: string) => StateType<DataType>,
  SET: (_state: StateType<DataType>, data: (DataType & ID)[]) => StateType<DataType>,
}

export function CRUDReducers<DataType>(fields: ReadonlyArray<string>, defaultDataOverride?: Partial<DataType>): CRUDReducer<DataType> {
  return {
    CREATE(state: StateType<DataType>, id: string, data?: Partial<DataType>): StateType<DataType> {
      return {
        ...state,
        [id]: {
          ...defaults<DataType>(fields),
          ...defaultDataOverride,
          id,
          ...data,
        },
      };
    },
    UPDATE(state: StateType<DataType>, data: Partial<DataType>, id: string): StateType<DataType> {
      return {
        ...state,
        [id]: {
          ...state[id],
          ...data,
        },
      };
    },
    DELETE(state: StateType<DataType>, id: string): StateType<DataType> {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: remove, ...rest } = state;
      return rest;
    },
    SET(_state: StateType<DataType>, data: (DataType & ID)[]): StateType<DataType> {
      return data.reduce((prev, current) => ({
        ...prev,
        [current.id]: current,
      }), {});
    },
  };
}

export const RecordModel = <DataType>(fields: ReadonlyArray<string>, defaultDataOverride?: Partial<DataType>) => ({
  state: {} as StateType<DataType>,
  reducers: {
    ...CRUDReducers<DataType>(fields, defaultDataOverride),
  },
});
